import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxDataGridModule } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { NestleDeactivationGridViewDto, NestleDeactivationType } from '@services';
import { GridPageComponent } from 'src/app/pages/common/grid-page.component';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';
import EnumUtils from 'src/app/shared/enum-utils';
import { UserStatusUpdatePopupComponent } from '../user-status-update-popup/user-status-update-popup.component';
import { YES_NO_OPTIONS } from 'src/app/shared/constants';

@Component({
    selector: 'app-nestle-deactivation-history',
    templateUrl: './nestle-deactivation-history.component.html',
    imports: [CommonModule, DxButtonModule, DxDataGridModule, UserAvatarEmailComponent, UserStatusUpdatePopupComponent]
})
export class NestleDeactivationHistoryComponent extends GridPageComponent<NestleDeactivationGridViewDto> implements OnInit {
    @Input() userId: string;

    protected override exportName = 'Nestle Deactivation History';
    protected dataSource?: CustomStore;
    protected readonly yesNoOptions = YES_NO_OPTIONS;
    protected readonly typeOptions = EnumUtils.getEnumOptions(NestleDeactivationType);

    constructor() {
        super();
        this.init(NestleDeactivationGridViewDto);
    }

    ngOnInit() {
        this.loadData();
    }

    // The section stays hidden until the employee has been terminated or deactivated at least once.
    loadData() {
        const store = this.dataSources.nestleDeactivationHistory(this.userId);
        store.totalCount({}).then(count => this.dataSource = count > 0 ? store : undefined);
    }

    protected export() {
        this.onExporting({ component: this.dataGrid.instance });
    }

    protected getTypeBadgeClass(type: NestleDeactivationType): string {
        return type === NestleDeactivationType.Inactive ? 'bg-warning-subtle text-warning' : 'bg-danger-subtle text-danger';
    }
}
